import React from 'react';
import ProjectList from '../components/ProjectList';
import projects from '../data/projects';

const ProjectsPage = () => {
    return <ProjectList heading="JavaScript Projects" projects={projects} />;
}

export default ProjectsPage;